export default{
    Basicinfoxu:{
        titleState:{
            title1:'用户名：',
            title2:'手机号：',
            title3:'身份：',
            title4:'个人认证',
            title5:'企业认证',
            title6:'安全设置',
        },
        showList:{
            show1:'登录密码',
            show2:'建议您定期更换密码，设置安全性高的密码可以使账号更安全',
            show3:'安全手机',
            show4:'安全手机可以用于登录账号，重置密码或其他安全验证',
            show5:'支付密码',
            show6:'在使用信用支付时需输入支付密码以保证您的资金安全',
            show7:'安全服务提示',
            show8:'注意防范进入钓鱼网站，不要轻信各种即时通讯工具发送的商品或支付链接，谨防网购诈骗。',
        },
        Passwordinfo:{
            pass1:'修改密码',
            pass2:'原密码',
            pass3:'新密码',
            pass4:'确认密码',
            pass5:'设置支付密码',
            pass6:'请输入6位纯数字支付密码',
            pass7:'请再次输入6位纯数字支付密码',
            pass8:'密码不一致，请重新输入',
            pass9:'请输入密码',
            pass10:'密码修改成功！',
            pass11:'请输入6-12位数字/字母/下划线组成的密码',
        },
        btnList:{
            btn1:'修改',
            btn2:'设置密码',
            btn3:'取消',
            btn4:'确定'
        }
    }
    
}